module.exports = __webpack_public_path__ + "static/media/icono_mas.fe47e33a.svg";